import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsBoost from 'highcharts/modules/boost';
import { TranslateService } from '@ngx-translate/core';
import { AlarmsService } from '@equipment/services/alarms.service';
import { first } from 'rxjs/operators';
import { customDateFormat, DateService } from '@shared/services/date.service';

const COLORS = [
  '#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99',
  '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a',
  '#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
  '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'
];

HighchartsBoost(Highcharts);

@Component({
  selector: 'app-lost-fluid-chart',
  templateUrl: './lost-fluid-chart.component.html',
  styleUrls: ['./lost-fluid-chart.component.scss']
})
export class LostFluidChartComponent implements OnInit {
  @Input() alarmId: string;
  public chartOptions: Highcharts.Options;
  public Highcharts: typeof Highcharts = Highcharts;
  private trInstant: (key: (string | Array<string>), interpolateParams?: Object) => any;
  private chartSeries = [];

  constructor(private dateService: DateService, private translateService: TranslateService, private alarmsService: AlarmsService) {
    this.trInstant = this.translateService.instant.bind(this.translateService);
  }

  ngOnInit(): void {
    this.alarmsService.getAlarmLostFluid(this.alarmId).pipe(first()).subscribe((lostFluid) => {
      const formattedData = lostFluid?.leakHistory?.map(item => [
        this.dateService.moment(item.date_time).valueOf(),
        item.leak
      ]);
      this.chartSeries.push({
        name: this.trInstant(this.trInstant('website.equipment.chart_lost_fluid.lost_fluid')),
        data: formattedData,
        type: 'line',
        color: COLORS[0],
        tooltip: {
          valueSuffix: 'g'
        }
      });
      this.initChart();
    }, (e) => {
      this.initChart();
    });
  }

  initChart(): void {
    const ctx = this;
    this.chartOptions = {
      chart: {
        zooming: {
          type: 'x'
        },
        type: 'line'
      },
      title: {
        text: ''
      },
      boost: {
        enabled: true
      },

      tooltip: {
        formatter() {
          return this.points.reduce((previous, current) => {
            return `${previous}<br/>${current.series.name}: ${current.y}${current.series.options.tooltip.valueSuffix}`;
          }, `<i>${ctx.trInstant('website.equipment.detail.charts.drag_to_zoom')}</i><br/><br/><b>${ctx.dateService.moment(this.x).format(customDateFormat.medium)}</b>`);
        },
        style: {
          color: '#66788a',
          fontWeight: 'normal',
          fontSize: '12px',
          letterSpacing: '-0.04px',
          lineHeight: '20px',
          fontFamily: 'Ubuntu'
        },
        shared: true,
        borderWidth: 0,
        backgroundColor: '#fff',
        borderRadius: 8,
        padding: 15
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        itemMarginBottom: 2,
        verticalAlign: 'top',
        floating: true,
        backgroundColor: Highcharts.defaultOptions.legend.backgroundColor
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: ['viewFullscreen'],
            symbol: 'url(../../../../../../assets/images/open_in_full.png)',
            symbolSize: 20,
            symbolX: 23,
            symbolY: 23
          }
        }
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: this.trInstant('website.equipment.chart_lost_fluid.time')
        }
      },
      yAxis: {
        title: {
          text: this.trInstant('website.equipment.chart_lost_fluid.leak')
        }
      },
      credits: {
        enabled: false
      },

      series: this.chartSeries
    };
  }


}
